import React, {Component} from 'react';
import {
    DropdownContextProps,
    Icon,
    keyCodes,
    PriorityIcon,
    TriggerWrapper,
    withDropdownContext
} from '@priority-software/priority-style-react';
import {SearchInput} from './SearchInput';
import {DropdownSearchProps} from './SearchDropdown';

class DropdownSearchInput extends Component<DropdownSearchProps & DropdownContextProps, any> {
    static defaultProps = {
        withArrowIcon: true
    };

    componentDidUpdate(prevProps: DropdownSearchProps) {
        const {dropdownContext, inputProps, closeOnClear} = this.props;
        const {value} = inputProps;
        if (value !== prevProps.inputProps.value && closeOnClear && (!value || !value.length)) {
            dropdownContext.closeDropdown(false);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true);
    }

    onFocus = () => {
        window.addEventListener('keydown', this.handleKeyDown, true);
        const {inputProps} = this.props;
        inputProps.onFocus && inputProps.onFocus();
    };

    onBlur = () => {
        window.removeEventListener('keydown', this.handleKeyDown, true);
        const {onTriggerBlur, inputProps} = this.props;
        onTriggerBlur();
        inputProps.onBlur && inputProps.onBlur();
    };

    handleKeyDown = e => {
        const {dropdownContext, inputProps} = this.props;

        switch (e.keyCode) {
            case keyCodes.ENTER:
                if (inputProps.value === '') {
                    dropdownContext.openDropdown();
                    e.stopPropagation();
                }
                break;
            default:
                break;
        }
    };

    render() {
        const {
            dropdownContext,
            inputProps,
            triggerRef,
            closeOnClear,
            withArrowIcon,
            withTriggerWrapper = true,
            withDataTestId = false,
            openOnFocus = false
        } = this.props;

        const arrowIcon = withArrowIcon ? (
            <Icon
                icon={dropdownContext.open ? PriorityIcon.arrowUp : PriorityIcon.arrowDown}
                iconColor="secondary-500"
                style={{fontSize: '20px', marginInlineEnd: '8px'}}
                onClick={dropdownContext.toggle}
            />
        ) : null;

        const searchInput = (
            <SearchInput
                {...inputProps}
                dropdownContext={dropdownContext}
                inputRef={triggerRef}
                icon={arrowIcon}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                closeOnClear={closeOnClear}
                handleSpreadsheetValues={inputProps.handleSpreadsheetValues}
                dataTestId={withDataTestId && 'drop-down-search-input'}
            />
        );
        return withTriggerWrapper ? (
            <TriggerWrapper dropdownContext={dropdownContext}>
                <div onClick={openOnFocus ? dropdownContext.toggle : undefined}>{searchInput}</div>
            </TriggerWrapper>
        ) : (
            searchInput
        );
    }
}

const DropdownSearchTrigger = withDropdownContext(DropdownSearchInput);

export default DropdownSearchTrigger;
